import { render, staticRenderFns } from "./SlideShow.vue?vue&type=template&id=bec844b2&scoped=true&"
import script from "./SlideShow.vue?vue&type=script&lang=js&"
export * from "./SlideShow.vue?vue&type=script&lang=js&"
import style0 from "./SlideShow.vue?vue&type=style&index=0&id=bec844b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec844b2",
  null
  
)

export default component.exports